interface LoadingGridProps {
  count?: number;
}

export default function LoadingGrid({ count = 10 }: LoadingGridProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="animate-pulse">
          <div className="w-full aspect-video rounded-lg bg-background-200" />
          <div className="mt-2.5 h-4 w-4/5 rounded bg-background-200" />
          <div className="mt-2 h-3 w-1/2 rounded bg-background-100" />
        </div>
      ))}
    </div>
  );
}